import CrudCustom from '../../../libs/custom/CrudCustom';

let TransaksiPerjanjianPembelianService = new CrudCustom('/perjanjian-pembelians');
export default TransaksiPerjanjianPembelianService;
